import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import FreeThrowsAwardedPopupDetails from './FreeThrowsAwardedPopupDetails.vue'

export const FreeThrowsAwardedPopup = new PopupBuilder('Free Throws Awarded')
  .appendBody(FreeThrowsAwardedPopupDetails)
  .build()
